// Though PageBuilderModule is a server component and this could be in the same
// file, it's separate to avoid circular dependency between PDP and course page.

const moduleAttributes = `
      __typename
      ... on AccordionRecord { ...accordionFragment }
      ... on BulletsModuleBlockRecord { ...bulletsFragment }
      ... on CarouselRecord { ...carouselFragment }
      ... on ExpandCollapseModuleRecord { ...expandCollapseFragment }
      ... on InfoMediumRecord { ...infoMediaFragment }
      ... on ProgressModuleRecord { ...progressFragment }
      ... on RoundedBannerRecord { ...roundedBannerFragment }
      ... on StatsModuleRecord { ...statsFragment }
      ... on StoryListRecord { ...storiesFragment }
      ... on StorytellingRecord { ...storytellingFragment }
`;

export const moduleForPageBuilderFragment = `
  fragment moduleForPageBuilderFragment on ModuleForPageBuilderRecord {
    htmlIdAttribute
    id
    module {
      ${moduleAttributes}
    }
  }
`;

export const moduleForSecondaryNavigationFragment = `
  fragment moduleForSecondaryNavigationFragment on ModuleForSecondaryNavigationRecord {
    htmlIdAttribute
    id
    module {
      ${moduleAttributes}
    }
    navigationTabTitle
  }
`;
